function isEmpty () {}

export default {
  regionTitle: [
    {
      required: true,
      // validator: validMobile,
      trigger: "change",
      message: '请输入专区名称'
    },
  ],
  appUrl: [
    {
      required: true,
      trigger: 'change',
      message: '请上传APP配图',
    }
  ],
  webUrl: [
    {
      required: true,
      // message: '请上传WEB配图',
      trigger: 'change',
      validator (rule, val, cb) {
        if (!val) {
          cb(new Error('请上传WEB配图'))
        } else {
          cb()
        }
      }
    }
  ],
  showType: [
    {
      required: true,
      // validator: validMobile,
      trigger: "change",
      message: '请选择专区版式'
    }
  ],
  showNum: [
    {
      required: true,
      message: "请输入展示数量",
      trigger: "blur",
    }
  ]
}